import { CardRow } from "../../CardRow";
import { TextNoWrapEllipsis } from "nvs-design-system/dist/TextNoWrapEllipsis";
import { ProductCardProps } from "../types";
import { Label4, Label9 } from "@/src/components/typography/components/Label";
import { LabelMono5 } from "@/src/components/typography/components/LabelMono";
import { getUserProfileRoute } from "@/src/helpers/getUserProfileRoute";
import {
  formatSwooshHandle,
  formatTokenId,
} from "@/src/helpers/stringFormatters";
import { TextLink } from "@/src/components/links/components/TextLink";
import {
  PRODUCT_CARD_PRODUCT_NAME,
  PRODUCT_CARD_TOKEN_ID,
  PRODUCT_CARD_SWOOSH_HANDLE,
} from "../testIds";

export function ProductCardContent(props: ProductCardProps) {
  return (
    <CardRow className="p-xs w-full min-h-[5rem]">
      <Label4 as="h2" data-testid={PRODUCT_CARD_PRODUCT_NAME}>
        {props.tokenName && (
          <TextNoWrapEllipsis>{props.tokenName}</TextNoWrapEllipsis>
        )}
      </Label4>
      <LabelMono5
        className="text-gray-350"
        as="h3"
        data-testid={PRODUCT_CARD_TOKEN_ID}
      >
        {props.tokenId && (
          <TextNoWrapEllipsis>
            {formatTokenId(props.tokenId)}
          </TextNoWrapEllipsis>
        )}
      </LabelMono5>
      <Label9 className="mt-xs relative z-1" as="h4">
        {props.swooshHandle && (
          <TextLink
            href={getUserProfileRoute(props.swooshHandle)}
            className="max-w-full"
            data-testid={PRODUCT_CARD_SWOOSH_HANDLE}
          >
            <TextNoWrapEllipsis>
              {formatSwooshHandle(props.swooshHandle)}
            </TextNoWrapEllipsis>
          </TextLink>
        )}
      </Label9>
    </CardRow>
  );
}
